
function closeModal() {
	document.getElementById('equipment-modal')?.classList.add('hidden');
}

function attachDropdownLogic() {
	document.querySelectorAll('.toggle-faq').forEach(btn => {
	btn.addEventListener('click', () => {
		const dd = btn.parentElement.nextElementSibling;
		const [closeIcon, openIcon] = btn.querySelectorAll('img');
		const isOpen = dd.classList.contains('hidden');

		document.querySelectorAll('dd').forEach(el => el.classList.add('hidden'));
		document.querySelectorAll('.toggle-faq img:nth-child(1)').forEach(i => i.classList.remove('hidden'));
		document.querySelectorAll('.toggle-faq img:nth-child(2)').forEach(i => i.classList.add('hidden'));

		if (isOpen) {
		dd.classList.remove('hidden');
		closeIcon.classList.add('hidden');
		openIcon.classList.remove('hidden');
		}
	});
	});
}

function moveToCustomiseYourLease() {
  const target = document.querySelector('#customise_your_vehicle_options_container');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener("DOMContentLoaded", function () {

  
  document.querySelectorAll('.customise_your_lease').forEach(button => {
    button.addEventListener('click', moveToCustomiseYourLease);
  });

  document.querySelectorAll('.close_modal').forEach(button => {
    button.addEventListener('click', closeModal);
  });

  document.querySelectorAll('.see_more').forEach(button => {
    button.addEventListener('click', async function () {
      const dealId = this.dataset.id;
      const type = this.dataset.type;
      const modal = document.getElementById('equipment-modal');
      const container = document.getElementById('equipment-container');
      container.innerHTML = '';

      // helpers
      const toArray = (val) => {
        if (Array.isArray(val)) return val;
        if (val && typeof val === 'object') return Object.values(val).flat(Infinity);
        return typeof val !== 'undefined' ? [val] : [];
      };

      const itemText = (i) => {
        if (typeof i === 'string') return i;
        if (!i || typeof i !== 'object') return String(i ?? '');
        
        const base = i.name ?? i.label ?? i.title ?? i.description
          ?? Object.values(i).find(v => typeof v === 'string') ?? '';
        const extra =
          (i.note ?? i.value ?? i.text ?? '')
            ? ` <span class="opacity-70">(${i.note ?? i.value ?? i.text})</span>` : '';
        return `${base}${extra}`;
      };

      try {
        const res = await fetch(`/api/${type}/${dealId}`);
        const data = await res.json();
        
        const entity = data?.[type] ?? data?.car ?? data?.van ?? data?.vehicle ?? data;
        const equipment = entity?.equipment ?? {};

        if (!equipment || typeof equipment !== 'object' || Object.keys(equipment).length === 0) {
          container.innerHTML = '<p class="text-[#1A1A2E]">No equipment data available.</p>';
          modal.classList.remove('hidden');
          return;
        }

        for (const category in equipment) {
          const rawGroup = equipment[category];
          const itemsArr = toArray(rawGroup);
          
          const items = itemsArr
            .map(item => itemText(item))
            .filter(Boolean)
            .map(text => `<li>${text}</li>`)
            .join('');

          const html = `
            <div class="py-3 px-6 first:mt-0 last:mb-0 border border-[#D0D5DD] rounded-[6px] mb-2">
              <dt>
                <button type="button" class="flex w-full items-start justify-between text-left toggle-faq" aria-expanded="false">
                  <span class="font-normal text-[16px] leading-[24px] tracking-[0] text-[#1A1A2E]">${category}</span>
                  <span class="ml-6 flex h-7 items-center">
                    <img src="/themes/driveelectric/img/icons/close-2.svg" class="w-[20px] h-[20px]" />
                    <img src="/themes/driveelectric/img/icons/open.svg" class="w-[13px] h-[13px] hidden" />
                  </span>
                </button>
              </dt>
              <dd class="mt-2 pr-12 hidden">
                ${
                  items
                    ? `<ul class="font-normal text-[14px] list-disc ps-[20px]">${items}</ul>`
                    : `<p class="font-normal text-[14px] opacity-70">No items listed.</p>`
                }
              </dd>
            </div>`;
          container.insertAdjacentHTML('beforeend', html);
        }

        attachDropdownLogic();
        modal.classList.remove('hidden');
      } catch (err) {
        container.innerHTML = '<p class="text-red-500">Failed to load equipment.</p>';
        console.error(err);
      }
    });
  });

});

